import "liquid-ajax-cart";
import "./theme.css";
import AlpineCollapse from "@alpinejs/collapse";

// Import vendor dependencies first
import "@/vendor";

import AlpineFocus from "@alpinejs/focus";
import AlpineIntersect from "@alpinejs/intersect";
import AlpineMorph from "@alpinejs/morph";
import accordion from "@data/accordion";
import contentCarousel from "@data/content-carousel";
import eventDetail from "@data/event-detail";
import eventList from "@data/event-list";
import imageLoader from "@data/image-loader";
// Import Alpine.js data components
import megaMenu from "@data/mega-menu";
import mobileMenu from "@data/mobile-menu";
import modal from "@data/modal";
import toggle from "@data/toggle";
import videoPlayer from "@data/video-player";
import formHandler from "@/components/form-handler";
import flatpickrDirective from "@/directives/flatpickr";
import Alpine from "alpinejs";

// import helpers from './js/helpers.js';

// const ns = 'selig';

// window.seligNamespace = ns;
// window[ns] = window[ns] || {};
// window[ns].helpers = helpers;

// for (const [key, value] of Object.entries(helpers)) {
//     window[ns].helpers[key] = value;
// }

// Register and initialize AlpineJS
window.Alpine = Alpine;

// Set reCAPTCHA site key on window before Alpine starts
window.RECAPTCHA_SITE_KEY = "6LcHBWctAAAAAHOlXvculiN0krymX-LRE2RRklQg";

// Register Alpine plugins
Alpine.plugin([AlpineCollapse, AlpineFocus, AlpineMorph, AlpineIntersect]);

// Register Alpine directives
flatpickrDirective(Alpine);

// Register Alpine.js data components
Alpine.data("megaMenu", megaMenu);
Alpine.data("modal", modal);
Alpine.data("toggle", toggle);
Alpine.data("mobileMenu", mobileMenu);
Alpine.data("contentCarousel", contentCarousel);
Alpine.data("eventDetail", eventDetail);
Alpine.data("eventList", eventList);
Alpine.data("imageLoader", imageLoader);
Alpine.data("videoPlayer", videoPlayer);
Alpine.data("accordion", accordion);
Alpine.data("formHandler", formHandler);

// Defer Alpine.start() to ensure DOM is ready and all registrations are complete
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => Alpine.start());
} else {
    queueMicrotask(() => Alpine.start());
}

// window.formStyles = window.formStyles || new Map();
// window.formStyles.set('my-custom-rules', 'form { border: 1px solid black; } button { color: red !important }');
